/**
 * checkbox
 * @author yangqizhang@medlinker.com
 */

import React from 'react';
import cn from 'classnames';

import styles from './styles.module.scss';

interface Props {
  checked: boolean;
  classes?: string;
  onChange: (checked: boolean) => void;
}

export default function Switch(props: Props) {
  return (
    <label className={styles.switch}>
      <input
        type="checkbox"
        checked={props.checked}
        onChange={e => {
          props.onChange(e.target.checked);
        }}
      />
      <i className={cn(styles.icon, { [styles.active]: props.checked })} />
    </label>
  );
}

Switch.defaultProps = {
  onChange: () => {},
};
